import React, { useState } from "react";
import NavLinks from "./NavLinks";
import SideBarLinks from "./SideBarLinks";

const StickyNavBar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleSideBarToggle = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <nav className="h-16 bg-gradient-to-r from-primary to-secondary flex items-center justify-between px-4 text-base lg:py-4 lg:h-auto sticky top-0 z-10">
      {isSidebarOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur z-30 lg:hidden"></div>
      )}

      <ul
        className={`lg:hidden fixed top-0 right-0 h-screen overflow-y-scroll bg-white transition-transform transform z-50 p-7 ${
          isSidebarOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <button type="button"
          onClick={handleSideBarToggle}
          className="absolute top-5 left-3 lg:hidden z-50"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="size-8 text-dark"
          >
            <path
              fillRule="evenodd"
              d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
              clipRule="evenodd"
            />
          </svg>
        </button>
        <li className="lg:hidden">
          <img
            className="w-64 py-4 mx-auto"
            src="/images/header_original_logo.jpg"
            alt="logo  "
          />
        </li>
        <SideBarLinks
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="size-6 inline-block"
            >
              <path d="M11.47 3.841a.75.75 0 0 1 1.06 0l8.69 8.69a.75.75 0 1 0 1.06-1.061l-8.689-8.69a2.25 2.25 0 0 0-3.182 0l-8.69 8.69a.75.75 0 1 0 1.061 1.06l8.69-8.689Z" />
              <path d="m12 5.432 8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75V21a.75.75 0 0 1-.75.75H5.625a1.875 1.875 0 0 1-1.875-1.875v-6.198a2.29 2.29 0 0 0 .091-.086L12 5.432Z" />
            </svg>
          }
          setIsSidebarOpen={setIsSidebarOpen}
          content={"  الرئيسية"}
          dropdown={false}
          url={'/'}
        />
        <SideBarLinks
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="size-6 inline-block"
            >
              <path
                fillRule="evenodd"
                d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm11.378-3.917c-.89-.777-2.366-.777-3.255 0a.75.75 0 0 1-.988-1.129c1.454-1.272 3.776-1.272 5.23 0 1.513 1.324 1.513 3.518 0 4.842a3.75 3.75 0 0 1-.837.552c-.676.328-1.028.774-1.028 1.152v.75a.75.75 0 0 1-1.5 0v-.75c0-1.279 1.06-2.107 1.875-2.502.182-.088.351-.199.503-.331.83-.727.83-1.857 0-2.584ZM12 18a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
                clipRule="evenodd"
              />
            </svg>
          }
          content={"عن الجمعية"}
          setIsSidebarOpen={setIsSidebarOpen}
          dropdown={true}
          dropdownItems={[
            
            {
              label: 'الرؤية',
              href: "/about_the_association/vision",
            },
            {
              label: 'الرسالة',
              href: "/about_the_association/message",
            },
            {
              label: "شهادة تسجيل الجمعية",
              href: "/about_the_association/commercial_registration",
            },
            {
              label: 'الهيكل التنظيمي',
              href: "/about_the_association/organizational_structure",
            },
            {
              label: 'تواصل معنا',
              href: "/contact",
            },
          ]}
        />
        <SideBarLinks
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="size-6 inline-block"
            >
              <path
                fill="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5"
              />
            </svg>
          }
          content={"الحوكمة"}
          setIsSidebarOpen={setIsSidebarOpen}
          dropdown={true}
          dropdownItems={[
            {
              label: `
            الشهادات والاعتمادات
          `,
              href: "/certificates_and_accreditations",
              icon: "",
            },
            {
              label: `
            القوائم المالية
          `,
              href: "/financial_statements",
              icon: "",
            },
            {
              label: `لائحة وسياسات الجمعية`,
              href: "/association_regulation_and_policies",
              icon: "",
            },
            {
              label: `
            تقرير مجلس الإدارة
          `,
              href: "/board_of_directors_reports",
              icon: "",
            },
          ]}
        />
        <SideBarLinks
          icon={
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 28 28"><path fill="currentColor" d="M22 5.75V20.5a.5.5 0 0 0 .992.09L23 20.5V7h1.25a1.75 1.75 0 0 1 1.744 1.606L26 8.75v12a3.25 3.25 0 0 1-3.066 3.245L22.75 24H5.25a3.25 3.25 0 0 1-3.245-3.066L2 20.75v-15a1.75 1.75 0 0 1 1.606-1.744L3.75 4h16.5a1.75 1.75 0 0 1 1.744 1.606zV20.5zM9.747 13.004H7.25a1.75 1.75 0 0 0-1.744 1.606l-.006.144v2.496a1.75 1.75 0 0 0 1.606 1.744L7.25 19h2.497a1.75 1.75 0 0 0 1.744-1.607l.005-.143v-2.496a1.75 1.75 0 0 0-1.606-1.745zM17.75 17.5h-3.5l-.102.007a.75.75 0 0 0 0 1.486l.102.007h3.5l.102-.007a.75.75 0 0 0 0-1.486zm-10.5-2.996h2.497a.25.25 0 0 1 .243.192l.007.058v2.496a.25.25 0 0 1-.193.243l-.057.007H7.25a.25.25 0 0 1-.243-.193L7 17.25v-2.496a.25.25 0 0 1 .193-.244zh2.497zm10.5-1.5h-3.5l-.102.006a.75.75 0 0 0 0 1.487l.102.007h3.5l.102-.007a.75.75 0 0 0 0-1.487zm0-4.507H6.25l-.102.007a.75.75 0 0 0 0 1.486l.102.007h11.5l.102-.007a.75.75 0 0 0 0-1.486z"/></svg>
          }
          content={"المركز الإعلامي"}
          setIsSidebarOpen={setIsSidebarOpen}
          dropdown={true}
          dropdownItems={[
            {
              label:"الأخبار والتقارير الإعلامية",
              href: "/news",
              icon: "",
            },
            {
              label:"استبيان قياس رضا المستفيدين والزوار",
              href: "/media_center/measuring_beneficiary_satisfaction",
              icon: "",
            },
            {
              label:"استبيان قياس رضا الموظفين والمتطوعين",
              href: "/media_center/staff_and_volunteer_satisfaction_survey",
              icon: "",
            },
          ]}
        />
        
        <SideBarLinks
          icon={
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" fill="currentColor" className="size-6 inline-block"><circle cx="16.86" cy="9.73" r="6.46" fill="#000"/><path fill="#000" d="M21 28h7v1.4h-7z"/><path fill="#000" d="M15 30v3a1 1 0 0 0 1 1h17a1 1 0 0 0 1-1V23a1 1 0 0 0-1-1h-7v-1.47a1 1 0 0 0-2 0V22h-2v-3.58a32 32 0 0 0-5.14-.42a26 26 0 0 0-11 2.39a3.28 3.28 0 0 0-1.88 3V30Zm17 2H17v-8h7v.42a1 1 0 0 0 2 0V24h6Z"/></svg>
          }
          setIsSidebarOpen={setIsSidebarOpen}
          content={'التوظيف'}
          url={'/employment'}
        />

        <SideBarLinks
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="size-6 inline-block"
            >
              <path
                fillRule="evenodd"
                d="M12 2.25c-2.429 0-4.817.178-7.152.521C2.87 3.061 1.5 4.795 1.5 6.741v6.018c0 1.946 1.37 3.68 3.348 3.97.877.129 1.761.234 2.652.316V21a.75.75 0 0 0 1.28.53l4.184-4.183a.39.39 0 0 1 .266-.112c2.006-.05 3.982-.22 5.922-.506 1.978-.29 3.348-2.023 3.348-3.97V6.741c0-1.947-1.37-3.68-3.348-3.97A49.145 49.145 0 0 0 12 2.25ZM8.25 8.625a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Zm2.625 1.125a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm4.875-1.125a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z"
                clipRule="evenodd"
              />
            </svg>
          }
          setIsSidebarOpen={setIsSidebarOpen}
          content={"اتصل بنا"}
          url={'/contact'}
        />
      </ul>

      <ul className="hidden  min-h-0 translate-x-0 bg-inherit lg:flex max-w-5xl flex-wrap justify-center items-center mx-auto text-white relative z-30 ">
        <li className="lg:hidden">
          <img
            className="w-64 py-4 mx-auto"
            src="/images/header_original_logo.jpg"
            alt="logo  "
          />
        </li>
        <NavLinks
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="size-4 inline-block"
            >
              <path d="M11.47 3.841a.75.75 0 0 1 1.06 0l8.69 8.69a.75.75 0 1 0 1.06-1.061l-8.689-8.69a2.25 2.25 0 0 0-3.182 0l-8.69 8.69a.75.75 0 1 0 1.061 1.06l8.69-8.689Z" />
              <path d="m12 5.432 8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75V21a.75.75 0 0 1-.75.75H5.625a1.875 1.875 0 0 1-1.875-1.875v-6.198a2.29 2.29 0 0 0 .091-.086L12 5.432Z" />
            </svg>
          }
          content={"  الرئيسية"}
          dropdown={false}
        ></NavLinks>
        <NavLinks
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="size-4 inline-block"
            >
              <path
                fillRule="evenodd"
                d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm11.378-3.917c-.89-.777-2.366-.777-3.255 0a.75.75 0 0 1-.988-1.129c1.454-1.272 3.776-1.272 5.23 0 1.513 1.324 1.513 3.518 0 4.842a3.75 3.75 0 0 1-.837.552c-.676.328-1.028.774-1.028 1.152v.75a.75.75 0 0 1-1.5 0v-.75c0-1.279 1.06-2.107 1.875-2.502.182-.088.351-.199.503-.331.83-.727.83-1.857 0-2.584ZM12 18a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
                clipRule="evenodd"
              />
            </svg>
          }
          content={"عن الجمعية"}
          dropdown={true}
          dropdownItems={[
            
            {
              label: 'الرؤية',
              href: "/about_the_association/vision",
            },
            {
              label: 'الرسالة',
              href: "/about_the_association/message",
            },
            {
              label: "شهادة تسجيل الجمعية",
              href: "/about_the_association/commercial_registration",
            },
            {
              label: 'الهيكل التنظيمي',
              href: "/about_the_association/organizational_structure",
            },
            {
              label: 'تواصل معنا',
              href: "/contact",
            },
          ]}
        ></NavLinks>
        <NavLinks
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="size-4 inline-block"
            >
              <path
                fill="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5"
              />
            </svg>
          }
          content={"الحوكمة"}
          dropdown={true}
          dropdownItems={[
            {
              label: `
            الشهادات والاعتمادات
          `,
              href: "/certificates_and_accreditations",
              icon: "",
            },
            {
              label: `
            القوائم المالية
          `,
              href: "/financial_statements",
              icon: "",
            },
            {
              label: `لائحة وسياسات الجمعية`,
              href: "/association_regulation_and_policies",
              icon: "",
            },
            {
              label: `
            تقرير مجلس الإدارة
          `,
              href: "/board_of_directors_reports",
              icon: "",
            },
          ]}
        ></NavLinks>
        <NavLinks
          icon={
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 28 28"><path fill="currentColor" d="M22 5.75V20.5a.5.5 0 0 0 .992.09L23 20.5V7h1.25a1.75 1.75 0 0 1 1.744 1.606L26 8.75v12a3.25 3.25 0 0 1-3.066 3.245L22.75 24H5.25a3.25 3.25 0 0 1-3.245-3.066L2 20.75v-15a1.75 1.75 0 0 1 1.606-1.744L3.75 4h16.5a1.75 1.75 0 0 1 1.744 1.606zV20.5zM9.747 13.004H7.25a1.75 1.75 0 0 0-1.744 1.606l-.006.144v2.496a1.75 1.75 0 0 0 1.606 1.744L7.25 19h2.497a1.75 1.75 0 0 0 1.744-1.607l.005-.143v-2.496a1.75 1.75 0 0 0-1.606-1.745zM17.75 17.5h-3.5l-.102.007a.75.75 0 0 0 0 1.486l.102.007h3.5l.102-.007a.75.75 0 0 0 0-1.486zm-10.5-2.996h2.497a.25.25 0 0 1 .243.192l.007.058v2.496a.25.25 0 0 1-.193.243l-.057.007H7.25a.25.25 0 0 1-.243-.193L7 17.25v-2.496a.25.25 0 0 1 .193-.244zh2.497zm10.5-1.5h-3.5l-.102.006a.75.75 0 0 0 0 1.487l.102.007h3.5l.102-.007a.75.75 0 0 0 0-1.487zm0-4.507H6.25l-.102.007a.75.75 0 0 0 0 1.486l.102.007h11.5l.102-.007a.75.75 0 0 0 0-1.486z"/></svg>
          }
          content={"المركز الإعلامي"}
          dropdown={true}
          dropdownItems={[
            {
              label: "الأخبار والتقارير الإعلامية",
              href: "/news",
              icon: "",
            },
            {
              label:"استبيان قياس رضا المستفيدين والزوار",
              href: "/media_center/measuring_beneficiary_satisfaction",
              icon: "",
            },
            {
              label:"استبيان قياس رضا الموظفين والمتطوعين",
              href: "/media_center/staff_and_volunteer_satisfaction_survey",
              icon: "",
            },
          ]}
        />

        <NavLinks
          icon={
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 36 36"><circle cx="16.86" cy="9.73" r="6.46" fill="currentColor"/><path fill="currentColor" d="M21 28h7v1.4h-7z"/><path fill="currentColor" d="M15 30v3a1 1 0 0 0 1 1h17a1 1 0 0 0 1-1V23a1 1 0 0 0-1-1h-7v-1.47a1 1 0 0 0-2 0V22h-2v-3.58a32 32 0 0 0-5.14-.42a26 26 0 0 0-11 2.39a3.28 3.28 0 0 0-1.88 3V30Zm17 2H17v-8h7v.42a1 1 0 0 0 2 0V24h6Z"/></svg>
          }
          content={'التوظيف'}
          url="/employment"
        />

        <NavLinks
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="size-4 inline-block"
            >
              <path
                fillRule="evenodd"
                d="M12 2.25c-2.429 0-4.817.178-7.152.521C2.87 3.061 1.5 4.795 1.5 6.741v6.018c0 1.946 1.37 3.68 3.348 3.97.877.129 1.761.234 2.652.316V21a.75.75 0 0 0 1.28.53l4.184-4.183a.39.39 0 0 1 .266-.112c2.006-.05 3.982-.22 5.922-.506 1.978-.29 3.348-2.023 3.348-3.97V6.741c0-1.947-1.37-3.68-3.348-3.97A49.145 49.145 0 0 0 12 2.25ZM8.25 8.625a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Zm2.625 1.125a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm4.875-1.125a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z"
                clipRule="evenodd"
              />
            </svg>
          }
          content={"اتصل بنا"}
          url="/contact"
        />
        
      </ul>
      <p className="text-sm text-background lg:hidden">
        جمعية التنمية الأهلية بجزيرة دارين
      </p>
      <div
        onClick={handleSideBarToggle}
        className="bg-dark w-auto inline-block p-1 rounded-sm cursor-pointer lg:hidden"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2.2}
          stroke="currentColor"
          className="size-6 text-white"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
          />
        </svg>
      </div>
    </nav>
  );
};

export default StickyNavBar;
